import styled from 'styled-components';
import _Button from 'components/button';
import _ShareSurfaceModal from './components/share-surface-modal';
import { normalize } from 'utils/styles';
import { color, typography } from 'styles/settings';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Button = styled(_Button)`
  padding: ${normalize('4px')} ${normalize('6px')};
`;

export const RoleIndicator = styled.div`
  border: 1px solid #dcaa4e;
  background: #dcaa4e33;
  border-radius: ${normalize('4px')} 0px;
  padding: ${normalize('6px')} ${normalize('10px')};
  color: ${color.brand.gold};
  font-family: ${typography.font.semiBold};
  font-size: ${typography.size.md};
  margin-right: ${normalize('10px')};
  margin-left: ${normalize('10px')};
`;

export const SharedIndicator = styled.div`
  position: absolute;
  right: ${normalize('12px')};
  top: ${normalize('6px')};
  width: ${normalize('10px')};
  height: ${normalize('10px')};

  background: ${color.brand.gold} 0% 0% no-repeat padding-box;
  border: 2px solid #ffffff;
  border-radius: 50%;
`;

export const ShareSurfaceModal = styled(_ShareSurfaceModal)`
  overflow: visible;
`;
